'use client'

import { useEffect, useRef, useState } from 'react'
import { getLiveData } from '@schleegleixner/react-statamic-api'

interface LocalWeather {
  cloud_cover: number
  humidity: number
  irradiation: number
  precipitation: number
  pressure: number
  avgrain: number
  rain_amount: number
  avgsolar_radiation: number
  temperature: number
  wind_direction: number
  wind_speed: number
  solar_radiation: number
}

const getLocalWeather = async () => {
  const response = await getLiveData('thingsboard/weather', 1)

  if (response !== null) {
    const payload = Object.entries(response)
      .map(([key, value]) => ({
        key,
        value: isNaN(Number(value)) ? value : Number(value),
      }))
      .sort((a, b) => {
        if (typeof a.value === 'number' && typeof b.value === 'number') {
          return a.value - b.value
        } else if (typeof a.value === 'string' && typeof b.value === 'string') {
          return a.value.localeCompare(b.value)
        }
        return typeof a.value === 'number' ? -1 : 1
      })
      .reduce((acc, { key, value }) => ({ ...acc, [key]: value }), {})

    return { ...payload }
  }

  return false
}

export default function useLocalWeather() {
  const [data, setData] = useState<LocalWeather | null>(null)
  const isFetching = useRef(false)

  useEffect(() => {
    if (isFetching.current) {
      return
    }
    isFetching.current = true

    getLocalWeather()
      .then(weatherData => {
        if (weatherData) {
          setData(weatherData as LocalWeather)
        }
      })
      .catch(() => {})
      .finally(() => {
        isFetching.current = false
      })
  }, [])

  return data
}
